export default __webpack_public_path__ + "4a28510c02c839818dc29c8e0649dc8a.png";